/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dynamics: NonNullable<unknown> }} Accident_Dynamics_LabelInputs */

const en_accident_dynamics_label = /** @type {(inputs: Accident_Dynamics_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.dynamics === "hit_parked_or_stationary_vehicle") return /** @type {LocalizedString} */ (`Hit a parked or stationary vehicle`);
	if (i?.dynamics === "both_maneuvering") return /** @type {LocalizedString} */ (`Both vehicles maneuvering`);
	if (i?.dynamics === "ran_stop_sign") return /** @type {LocalizedString} */ (`Ran stop sign`);
	if (i?.dynamics === "ran_red_light") return /** @type {LocalizedString} */ (`Ran red light`);
	if (i?.dynamics === "frontal_collision") return /** @type {LocalizedString} */ (`Frontal collision`);
	if (i?.dynamics === "side_collision") return /** @type {LocalizedString} */ (`Side collision`);
	if (i?.dynamics === "rear_collision") return /** @type {LocalizedString} */ (`Rear collision`);
	if (i?.dynamics === "illegal_turn") return /** @type {LocalizedString} */ (`Illegal turn`);
	if (i?.dynamics === "chain_collision") return /** @type {LocalizedString} */ (`Chain collision`);
	if (i?.dynamics === "invaded_right_of_way") return /** @type {LocalizedString} */ (`Invaded right of way`);
	if (i?.dynamics === "reversing") return /** @type {LocalizedString} */ (`Reversing`);
	if (i?.dynamics === "lane_change") return /** @type {LocalizedString} */ (`Lane change`);
	if (i?.dynamics === "lost_control") return /** @type {LocalizedString} */ (`Lost control of the vehicle`);
	if (i?.dynamics === "exited_parking_space_or_garage") return /** @type {LocalizedString} */ (`Exited a parking space or garage`);
	if (i?.dynamics === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.dynamics}`)
	
};

const pt_br2_accident_dynamics_label = /** @type {(inputs: Accident_Dynamics_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.dynamics === "hit_parked_or_stationary_vehicle") return /** @type {LocalizedString} */ (`Acidente com veículo parado ou estacionado`);
	if (i?.dynamics === "both_maneuvering") return /** @type {LocalizedString} */ (`Ambos estavam em manobra`);
	if (i?.dynamics === "ran_stop_sign") return /** @type {LocalizedString} */ (`Avanço de parada obrigatória`);
	if (i?.dynamics === "ran_red_light") return /** @type {LocalizedString} */ (`Avanço de sinal vermelho`);
	if (i?.dynamics === "frontal_collision") return /** @type {LocalizedString} */ (`Colisão frontal`);
	if (i?.dynamics === "side_collision") return /** @type {LocalizedString} */ (`Colisão lateral`);
	if (i?.dynamics === "rear_collision") return /** @type {LocalizedString} */ (`Colisão traseira`);
	if (i?.dynamics === "illegal_turn") return /** @type {LocalizedString} */ (`Conversão irregular`);
	if (i?.dynamics === "chain_collision") return /** @type {LocalizedString} */ (`Engavetamento`);
	if (i?.dynamics === "invaded_right_of_way") return /** @type {LocalizedString} */ (`Invasão de preferencial`);
	if (i?.dynamics === "reversing") return /** @type {LocalizedString} */ (`Marcha ré`);
	if (i?.dynamics === "lane_change") return /** @type {LocalizedString} */ (`Mudança de faixa`);
	if (i?.dynamics === "lost_control") return /** @type {LocalizedString} */ (`Perda do controle do veículo`);
	if (i?.dynamics === "exited_parking_space_or_garage") return /** @type {LocalizedString} */ (`Saída de vaga/garagem`);
	if (i?.dynamics === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.dynamics}`)
	
};

/**
* | dynamics | output |
* | --- | --- |
* | "hit_parked_or_stationary_vehicle" | "Hit a parked or stationary vehicle" |
* | "both_maneuvering" | "Both vehicles maneuvering" |
* | "ran_stop_sign" | "Ran stop sign" |
* | "ran_red_light" | "Ran red light" |
* | "frontal_collision" | "Frontal collision" |
* | "side_collision" | "Side collision" |
* | "rear_collision" | "Rear collision" |
* | "illegal_turn" | "Illegal turn" |
* | "chain_collision" | "Chain collision" |
* | "invaded_right_of_way" | "Invaded right of way" |
* | "reversing" | "Reversing" |
* | "lane_change" | "Lane change" |
* | "lost_control" | "Lost control of the vehicle" |
* | "exited_parking_space_or_garage" | "Exited a parking space or garage" |
* | "other" | "Other" |
* | * | "{dynamics}" |
*
* @param {Accident_Dynamics_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const accident_dynamics_label = /** @type {((inputs: Accident_Dynamics_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accident_Dynamics_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accident_dynamics_label(inputs)
	return pt_br2_accident_dynamics_label(inputs)
});